module.exports = __webpack_public_path__ + "img/gtj.ec44c91a.png";